import { Session } from "./global";
import { getAnalyticsId } from "./gtag";
import { retrieveAnonymousId } from "./segmentio";

/**
 * Save analytics state to ensure it persists across OAuth redirects.
 */
export async function save(): Promise<Session> {
  let sess = {} as Session;
  // Add analytics IDs to app state for preservation across OAuth redirects
  sess.anonymousId = await retrieveAnonymousId();

  const [gaClientId, gaSessionId] = await getAnalyticsId();
  sess.gaClientId = gaClientId;
  sess.gaSessionId = gaSessionId;

  return sess;
}
